/** Close comment stored when a recruiter marks a position Closed. */
export function positionCloseReason(position) {
  return String(position?.closeReason || position?.close_reason || '').trim();
}

function readStatusRaw(position) {
  return String(position?.status ?? position?.Status ?? position?.positionStatus ?? '').trim();
}

/**
 * Closed is the persisted status only ("Close" / "Closed").
 * Do not treat leftover closedAt as closed — that over-counts CLOSED vs Craft JD.
 */
export function isPositionClosed(position) {
  const lower = readStatusRaw(position).toLowerCase();
  return lower === 'close' || lower === 'closed';
}

/**
 * Same buckets as Craft JD widgets (DB status only, not ranking-complete).
 */
export function positionLifecycleBucket(position) {
  const lower = readStatusRaw(position).toLowerCase();
  if (lower === 'close' || lower === 'closed') return 'Closed';
  if (lower === 'stacked') return 'Stacked';
  return 'Pending';
}

/** Craft JD grid / filters use Close; widgets elsewhere use Closed. */
export function positionStatusKey(position) {
  const bucket = positionLifecycleBucket(position);
  return bucket === 'Closed' ? 'Close' : bucket;
}

/**
 * Stack Ranking list/widgets — must match Craft JD counts.
 * Ranking-complete must not move a Closed job, and must not invent extra Closed rows.
 */
export function stackRankingStatusBucket(position) {
  return positionLifecycleBucket(position);
}

/**
 * Display label for a position status.
 * Closed positions with a comment render as: Closed (Role filled)
 */
export function formatPositionStatusLabel(position) {
  const raw = readStatusRaw(position);
  const lower = raw.toLowerCase();
  if (isPositionClosed(position)) {
    const reason = positionCloseReason(position);
    return reason ? `Closed (${reason})` : 'Closed';
  }
  if (!raw) return 'Active';
  if (lower === 'stacked') return 'Stacked';
  if (lower === 'pending') return 'Pending';
  return raw;
}
